
import React from 'react';

const NotFound = () => {
    return (
        <div style={{ textAlign: 'center', padding: '50px', margin: '100px auto 0 auto'}}>
            <h1>404 - Not Found</h1>
            <p>The page you're looking for doesn't exist.</p>
        </div>
    );
};

export default NotFound;
